(function () {
  function pad(num) {
    return String(Math.max(0, num)).padStart(2, '0');
  }

  function tick(el, newValue) {
    if (el.textContent === newValue) return;
    el.textContent = newValue;
    el.classList.remove('is-tick');
    // force reflow so the animation can restart
    void el.offsetWidth;
    el.classList.add('is-tick');
  }

  function initCountdown(banner) {
    var endDateStr = banner.getAttribute('data-end-date');
    var expiredBehavior = banner.getAttribute('data-expired-behavior') || 'hide';
    var endDate = new Date(endDateStr.replace(' ', 'T') + 'Z').getTime();

    var daysEl = banner.querySelector('[data-days]');
    var hoursEl = banner.querySelector('[data-hours]');
    var minutesEl = banner.querySelector('[data-minutes]');
    var secondsEl = banner.querySelector('[data-seconds]');

    if (isNaN(endDate)) {
      banner.style.display = 'none';
      return;
    }

    function render() {
      var now = Date.now();
      var diff = endDate - now;

      if (diff <= 0) {
        if (expiredBehavior === 'hide') {
          banner.style.display = 'none';
        } else {
          tick(daysEl, '00');
          tick(hoursEl, '00');
          tick(minutesEl, '00');
          tick(secondsEl, '00');
        }
        clearInterval(intervalId);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      tick(daysEl, pad(days));
      tick(hoursEl, pad(hours));
      tick(minutesEl, pad(minutes));
      tick(secondsEl, pad(seconds));
    }

    render();
    var intervalId = setInterval(render, 1000);

    var codeBtn = banner.querySelector('[data-countdown-code]');
    if (codeBtn) {
      var originalHTML = codeBtn.innerHTML;
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-code');
        var copyText = function () {
          codeBtn.innerHTML = 'Copied!';
          codeBtn.classList.add('is-copied');
          setTimeout(function () {
            codeBtn.innerHTML = originalHTML;
            codeBtn.classList.remove('is-copied');
          }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(copyText).catch(copyText);
        } else {
          copyText();
        }
      });
    }
  }

  document.querySelectorAll('[data-countdown-banner]').forEach(initCountdown);
})();